// 截取url 里面的值
export const getQueryString = name => {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
    let params = window.location.search.substr(1) || window.location.href.split('?')[1]
    let r = params && params.match(reg)

    let param = window.location.hash.split('?')[1]
    let rs = param && param.match(reg)
    if (r != null) {
        if (name == 'name') {
            return decodeURIComponent(r[2])
        } else {
            return unescape(r[2])
        }
    } else {
        if (rs != null) {
            if (name == 'name') {
                return decodeURIComponent(rs[2])
            } else {
                return unescape(rs[2])
        }
      }
    }
    return null
}

export const is_android = () => {
    var ua = navigator.userAgent.toLocaleLowerCase()
    if (ua.indexOf('android') > -1 || ua.indexOf('linux') > -1) {
        return true
    } else {
        return false
    }
}
